import Dashboard from "./Dashboard";

export { default as reducer } from "./reducer";

export default Dashboard;
